import {
    SupplierInfo,
    CompanyCardVo,
    GetVideoAndPictureParam,
    CoCompanyCard,
    CooperatePageVo,
    CompanyVideoVo,
    UpdateVideoParam,
    SupplierDailyDeliveryVolumeResult
} from '@servicesTypings/drpRequest'
import { MainPlatformVo } from '@servicesTypings/companyRequest'
import { CoInvestmentRegistrationVo, QueryStatusUsingGetParams } from '@servicesTypings/marketRequest'
// 子账户管理
import { companyRequest, drpRequest, openDrpRequest, marketRequest } from '@/utils/request'

import { QuerySiteListDisplayParams } from '@servicesTypings/drpRequestV3'

// 查询负责人信息
/**
 * 加载商家基础资料详情
 */
export function load(): API.Res<SupplierInfo> {
    return drpRequest.get('/supplierInfo/load')
}

// 获取商家卡片信息
/**
 * 查询商家卡片
 */
export function queryCardApi(): API.Res<CompanyCardVo> {
    return drpRequest.get('/companyCard/queryCard')
}

// 查询商家主营平台和店铺数量(和供应商列表主营平台排序规则一致)
/**
 * 查询商家主营平台和店铺数量(和供应商列表主营平台排序规则一致)
 */
export function queryShopNumWithSorted(): API.Res<MainPlatformVo[]> {
    return companyRequest.get('/erpShopInfo/queryShopNumWithSorted')
}

// 获取商家视频和图片
/**
 * 获取商家视频和图片
 */
export function getVideoAndPicture(data: GetVideoAndPictureParam): API.Res<CoCompanyCard> {
    return drpRequest.post('/companyCard/getVideoAndPicture', { data })
}

// 未登录情况获取商家视频和图片
/**
 * 获取商家视频和图片
 */
export function getOpenVideoAndPicture(data: GetVideoAndPictureParam): API.Res<CoCompanyCard> {
    return openDrpRequest.post('/open/companyCard/getVideoAndPicture', { data })
}

// 更新商家卡片信息
/**
 * 编辑商家卡片
 */
export function updateCardApi(data: CompanyCardVo): API.Res<object> {
    return drpRequest.post('/companyCard/updateCard', { data })
}

// 获取页面准备信息
/**
 * 页面准备信息查询
 */
export function loadPageInfoApi(): API.Res<CooperatePageVo> {
    return drpRequest.get('/cooperate/page/info')
}

// 判断当前商家是否优质分销商
/**
 * 当前商家是否是优质分销商
 */
export function isQualityApi(): API.Res<boolean> {
    return drpRequest.get('/channel/isQuality')
}

// 获取当前商家视频
/**
 * 获取当前用户视频
 */
export function getMyVideoUrl(): API.Res<CompanyVideoVo[]> {
    return drpRequest.get('/companyCard/getMyVideoUrl')
}

// 修改当前商家视频链接
/**
 * 修改当前用户视频链接
 */
export function updateMyVideoUrl(data: UpdateVideoParam): API.Res<object> {
    return drpRequest.post('/companyCard/updateMyVideoUrl', { data })
}

/** 查询报名内容 */
/**
 * 查询报名内容
 */
export function queryRegistration(): API.Res<CoInvestmentRegistrationVo> {
    return marketRequest.get('/merchant/investment/queryRegistration')
}

/** 提交报名内容 */
/**
 * 提交报名内容
 */
export function submitRegistration(data: CoInvestmentRegistrationVo): API.Res<boolean> {
    return marketRequest.post('/merchant/investment/submitRegistration', { data })
}

/** 查询banner状态 */
/**
 * 查询大店的banner状态
 */
export function queryStatus(params: QueryStatusUsingGetParams): API.Res<Record<string, string>> {
    return marketRequest.get('/banner/queryStatus', { params })
}

/** 查询配置供应商日均发货单量 */
/**
 * 查询配置供应商日均发货单量
 */
export function getConfigSupplierDailyDeliveryVolume(): API.Res<SupplierDailyDeliveryVolumeResult[]> {
    return drpRequest.get('/supplier/getConfigSupplierDailyDeliveryVolume')
}

/**
 * 查询商家的小站榜单展示开关
 */
export function querySiteListDisplay(data): API.Res<Boolean> {
    return drpRequest.post('/companyCard/querySiteListDisplay', { data })
}
